export default __webpack_public_path__ + "static/media/banner2.b38ec218.png";